import { ChevronDown, Moon, Snowflake, Sun } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { Theme, useTheme } from '../theme/ThemeContext';
import './ThemeToggle.css';

const THEMES: { value: Theme; icon: React.ReactNode; label: string }[] = [
    { value: 'dark',  icon: <Moon size={14} />,      label: 'Тёмная'  },
    { value: 'light', icon: <Sun size={14} />,        label: 'Светлая' },
    { value: 'nord',  icon: <Snowflake size={14} />,  label: 'Nord'    },
];

export const ThemeToggle: React.FC = () => {
    const { theme, setTheme } = useTheme();
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const current = THEMES.find(t => t.value === theme)!;

    return (
        <div ref={ref} className="theme-toggle">
            <button
                className="theme-toggle__btn"
                onClick={() => setOpen(o => !o)}
                aria-label="Выбор темы"
                aria-expanded={open}
            >
                {current.icon}
                <span className="theme-toggle__label">{current.label}</span>
                <ChevronDown size={12} className={`theme-toggle__chevron${open ? ' open' : ''}`} />
            </button>

            {open && (
                <div className="theme-toggle__menu" role="menu">
                    {THEMES.map(t => (
                        <button
                            key={t.value}
                            role="menuitem"
                            className={`theme-toggle__option${t.value === theme ? ' active' : ''}`}
                            onClick={() => { setTheme(t.value); setOpen(false); }}
                        >
                            {t.icon}
                            <span>{t.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
